import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';

export const getImgixUrl = (photo?: string) => (photo ? `${IMAGES_BASE_URL}/${photo}` : undefined);
